module.exports = __webpack_public_path__ + "static/media/Goal_app.ecf48719.png";